import React, { Component } from "react";
import "./NodeManager.css";
import "./OrganizationDashboard.css";
import axios from "axios";
import "react-notifications-component/dist/theme.css";
import "animate.css";
import { store } from "react-notifications-component";
import EditIcon from "@material-ui/icons/Edit";
import { Form, FormGroup, Input } from "reactstrap";
import { UserTable } from "./UserTable";
import { NetworkTable } from "./NetworkTable";
import UserAddModal from "./UserAddModal";
import RemoveModal from "./RemoveModal";
import UserAdminModal from "./UserAdminModal";
import UUIDModal from "./UUIDModal";

class OrganizationDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      view_mode: "users",
      loaded: false,
      hasOrganization: false,
      userInfo: {},
      organization: {},
      filter: "",
      validationErrors: [],
      newNetwork: {
        name: "",
        description: "",
      },
      networkLeaveModal: false,
      descriptionEditToggle: false,
      edit_description: "",
      selectedUsers: [],
      selectedNetworks: [],
      userAddModal: false,
      userDeleteModal: false,
      userAdminModal: false,
      organizationUUID: "",
      UUIDmodal: false,
    };
  }
  componentDidMount() {
    this.getUserInfo();
  }

  handleDescriptionChange = (e) => {
    let description = e.target.value;
    this.setState({ edit_description: description });
  };

  isAdmin(user) {
    let admins = this.state.organization.admins;
    return admins.includes(user);
  }

  addUser = async (userEmail) => {
    const formData = new FormData();
    formData.append("add-users", userEmail);
    formData.append("_method", "PATCH");
    let valid = true
    await axios
      .patch(
        this.props.baseUrl +
          "/api/api/organization/" +
          this.state.organization.uuid +
          "/users/",
        formData,
        {
          headers: this.getHeaders(),
        }
      )
      .then(() => {
        this.getUserInfo();
        this.notify_add();
        this.setState({ validationErrors: [] });
        this.toggleModal("userAddModal");

      })
      .catch((errors) => {
        this.setState({ validationErrors: errors.response.data });
        valid = false
      });
    return valid;
  };

  removeUser = () => {
    const formData = new FormData();
    this.state.selectedUsers.forEach((user) => {
      formData.append("remove-users", user.email);
    });
    formData.append("_method", "PATCH");

    axios
      .patch(
        this.props.baseUrl +
          "/api/api/organization/" +
          this.state.organization.uuid +
          "/users/",
        formData,
        {
          headers: this.getHeaders(),
        }
      )
      .then((response) => {
        this.getUserInfo();
        this.notify_delete();
        this.setState({ validationErrors: [] });
        this.toggleModal("userDeleteModal");
      })
      .catch((errors) => {
        this.setState({ validationErrors: errors.response.data });
      });
    return;
  };

  leaveNetwork = () => {
    const formData = new FormData();
    this.state.selectedNetworks.forEach((network) => {
      formData.append("remove-networks", network.uuid);
    });
    formData.append("_method", "PATCH");

    axios
      .patch(
        this.props.baseUrl +
          "/api/api/organization/" +
          this.state.organization.uuid +
          "/networks/",
        formData,
        {
          headers: this.getHeaders(),
        }
      )
      .then((response) => {
        this.getUserInfo();
        this.notify_network_leave();
        this.setState({ validationErrors: [] });
        this.toggleModal("networkLeaveModal");
      })
      .catch((errors) => {
        this.setState({ validationErrors: errors.response.data });
      });
    return;
  };

  setAdmin = (user, action) => {
    const formData = new FormData();
    // action = 'remove-admins' or 'add-admins'
    formData.append(action, user.email);
    formData.append("_method", "PATCH");

    axios
      .patch(
        this.props.baseUrl +
          "/api/api/organization/" +
          this.state.organization.uuid +
          "/admins/",
        formData,
        {
          headers: this.getHeaders(),
        }
      )
      .then((response) => {
        this.getUserInfo();
        this.notify_admin();
        this.setState({ validationErrors: [] });
        this.toggleModal("userAdminModal");
      })
      .catch((errors) => {
        this.setState({ validationErrors: errors.response.data });
      });
    return;
  };

  getUUID = () => {
    this.setState({ organizationUUID: this.state.organization.uuid });
    this.setState({ UUIDmodal: true });
    return;
  };

  getUserStr = (selections, type) => {
    var i;
    var userStr = "";
    for (i = 0; i < selections.length; i++) {
      if (i === selections.length - 1 && i !== 0) {
        userStr += ", and ";
      } else if (i !== 0) {
        userStr += ", ";
      }
      if (type === "users") {
        userStr += selections[i].username;
      } else if (type === "networks") {
        userStr += selections[i].name;
      }
    }
    return userStr;
  };

  setUser = (users) => {
    this.setState({ selectedUsers: users });
  };

  setNetwork = (networks) => {
    this.setState({ selectedNetworks: networks });
  };

  toggleModal = (toggle) => {
    if (this.state[toggle]) {
      this.setState({ validationErrors: [] });
    }

    this.setState({ [toggle]: !this.state[toggle] });
  };

  editDescription = () => {
    const formData = new FormData();
    formData.append("description", this.state.edit_description);
    formData.append("_method", "PATCH");
    axios
      .patch(
        this.props.baseUrl +
          "/api/api/organization/" +
          this.state.organization.uuid +
          "/description/",
        formData,
        {
          headers: this.getHeaders(),
        }
      )
      .then((response) => {
        this.getUserInfo();
        this.setState({ validationErrors: [] });
        this.toggleModal("descriptionEditToggle");
      })
      .catch((errors) => {
        this.setState({ validationErrors: errors.response.data });
      });
    return;
  };

  renderErrors = () => {
    const validationErrors = this.state.validationErrors;
    const error_tags = ["name", "user"];

    let errors = [];

    for (var i = 0; i < error_tags.length; i++) {
      let error_msg = validationErrors[error_tags[i]];
      if (error_msg) {
        errors.push(<li key={error_tags[i]}>{error_msg}</li>);
      }
    }

    return errors;
  };

  toggleModal = (toggle) => {
    if (this.state[toggle]) {
      this.setState({ validationErrors: [] });
    }

    this.setState({ [toggle]: !this.state[toggle] });
  };

  getHeaders = () => {
    return {
      Authorization: `Token ${this.props.token}`,
    };
  };

  getUserInfo = () => {
    axios
      .get(this.props.baseUrl + "/api/api/users/me/", {
        headers: this.getHeaders(),
      })
      .then((res) => {
        this.setState({ userInfo: res.data });
        let organization = this.state.userInfo.profile.organization;
        if (organization !== null) {
          axios
            .get(
              this.props.baseUrl +
                "/api/api/organization/" +
                this.state.userInfo.profile.organization + '/by_uuid',
              {
                headers: this.getHeaders(),
              }
            )
            .then((res) => {
              this.setState({ organization: res.data });

              this.setState({ hasOrganization: true });
              this.setState({ loaded: true });
            })
            .catch((err) => {});
        } else {
          this.setState({ loaded: true });
        }
      })
      .catch((err) => {});
  };

  createNetwork = (network) => {
    const formData = new FormData();
    formData.append("name", network.name);
    formData.append("description", network.description);
    formData.append("users", this.state.userInfo.username);
    formData.append("admins", this.state.userInfo.username);

    axios
      .post(this.props.baseUrl + "/api/api/network/", formData, {
        headers: this.getHeaders(),
      })
      .then((response) => {
        this.getUserInfo();
        this.notify_create();
        this.setState({ validationErrors: [] });
        this.toggleModal("networkAddModal");
      })
      .catch((errors) => {
        this.setState({ validationErrors: errors.response.data });
      });
    return;
  };

  render() {
    return (
      <>
        {this.state.hasOrganization ? (
          <div className="organization">
            <div className="organization_title">
              <h1>{this.state.organization.name}</h1>
              <div className="toolti_right" style={{ padding: "0" }}>
                  <button
                    onClick={() => {
                      this.getUUID();
                    }}
                    className="view_network_button"
                  >
                    View UUID
                  </button>
                <span className="tooltitext" style={{ maxWidth: "400px" }}>
                  {"  "}Token needed to add your organization to networks. It will reset every time it is used.{"  "}
                </span>
              </div>
            </div>
            <div className="organization_description">
              {this.state.descriptionEditToggle ? (
                <Form
                  onSubmit={(event) => {
                    event.preventDefault();
                  }}
                >
                  <FormGroup className="form_group">
                    <Input
                      type="text"
                      name="description"
                      value={this.state.edit_description}
                      onChange={this.handleDescriptionChange}
                      placeholder="Enter network description"
                      maxLength="1000"
                    />
                    <button
                      className="save_button"
                      color="success"
                      onClick={() => {
                        this.editDescription();
                      }}
                    >
                      Save
                    </button>
                  </FormGroup>
                </Form>
              ) : (
                <>
                  {this.state.organization.description}

                  {this.isAdmin(this.state.userInfo.username) ? (
                    <div className="toolti">
                      <button
                        onClick={() => {
                          this.setState({
                            edit_description: this.state.organization
                              .description,
                          });
                          this.setState({ descriptionEditToggle: true });
                        }}
                        className="description_edit_button"
                      >
                        <EditIcon className="description_edit_icon"></EditIcon>
                      </button>
                      <span className="tooltitext">
                        {"  "}Edit description{"  "}
                      </span>
                    </div>
                  ) : null}
                </>
              )}
            </div>
            <div className="seletion_area">
              <div className="table_selection">
                <button
                  selected
                  onClick={() => {
                    this.setState({ view_mode: "users" });
                  }}
                  className={`info_selection_button ${
                    "users" === this.state.view_mode && "selected"
                  }`}
                >
                  Users
                </button>

                <button
                  onClick={() => {
                    this.setState({ view_mode: "networks" });
                  }}
                  className={`info_selection_button ${
                    "networks" === this.state.view_mode && "selected"
                  }`}
                >
                  Networks
                </button>
              </div>
              <div className="action_selection">
                {this.isAdmin(this.props.user) &&
                this.state.view_mode === "users" ? (
                  <div className="action_buttons">
                    <div className="toolti">
                      <button
                        onClick={() => this.setState({ userAddModal: true })}
                        className="action_button"
                      >
                        Add user
                      </button>
                      <span className="tooltitext">
                        {"  "}Add a new user{"  "}
                      </span>
                    </div>
                    <div className="toolti">
                      <button
                        disabled={this.state.selectedUsers.length === 0}
                        onClick={() => this.setState({ userDeleteModal: true })}
                        className="action_button3"
                      >
                        Remove user
                      </button>
                      {this.state.selectedUsers.length === 0 ? (
                        <span className="tooltitext">
                          {"  "}Select a user to remove from network{"  "}
                        </span>
                      ) : (
                        <span className="tooltitext">
                          {"  "}Remove user from network{"  "}
                        </span>
                      )}
                    </div>

                    <div className="toolti">
                      <button
                        disabled={this.state.selectedUsers.length !== 1}
                        onClick={() => {
                          this.setState({ userAdminModal: true });
                        }}
                        className="action_button2"
                      >
                        Admin rights
                      </button>
                      {this.state.selectedUsers.length !== 1 ? (
                        <span className="tooltitext">
                          {"  "}Select a user to edit admin rights{"  "}
                        </span>
                      ) : (
                        <span className="tooltitext">
                          {"  "}Edit user's admin rights{"  "}
                        </span>
                      )}
                    </div>
                  </div>
                ) : null}
                {this.isAdmin(this.props.user) &&
                this.state.view_mode === "networks" ? (
                  <div className="action_buttons">
                    <div className="toolti">
                      <button
                        disabled={this.state.selectedNetworks.length === 0}
                        onClick={() =>
                          this.setState({ networkLeaveModal: true })
                        }
                        className="action_button3"
                      >
                        Leave Network
                      </button>
                      {this.state.selectedUsers.length === 0 ? (
                        <span className="tooltitext">
                          {"  "}Select an network to leave
                          {"  "}
                        </span>
                      ) : (
                        <span className="tooltitext">
                          {"  "}Leave selected network{"  "}
                        </span>
                      )}
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
            <div className="info_table">
              {this.state.view_mode === "users" ? (
                <UserTable
                  users={this.state.organization.users}
                  admins={this.state.organization.admins}
                  setSelection={this.setUser}
                />
              ) : (
                <NetworkTable
                  networks={this.state.organization.networks}
                  setSelection={this.setNetwork}
                />
              )}
            </div>
            {this.state.userAddModal ? (
              <UserAddModal
                toggle={this.toggleModal}
                toggleName="userAddModal"
                getErrors={this.renderErrors}
                onSave={this.addUser}
                users={this.state.organization.users}
              />
            ) : null}

            {this.state.UUIDmodal ? (
              <UUIDModal
                title="Organization UUID"
                info="Token needed to add your organization to networks. It will reset every time it is used."
                uuid={this.state.organizationUUID}
                toggle={this.toggleModal}
                toggleName="UUIDmodal"
              />
            ) : null}

            {this.state.userDeleteModal ? (
              <RemoveModal
                toggle={this.toggleModal}
                toggleName="userDeleteModal"
                onSave={this.removeUser}
                message_body={
                  "Are you sure you want to remove user" +
                  (this.state.selectedUsers.length > 1 ? "s" : "") +
                  " " +
                  this.getUserStr(this.state.selectedUsers, "users") +
                  " from the network?"
                }
                message_header={"Leave Network"}
                saveButton={"Remove"}
              />
            ) : null}

            {this.state.networkLeaveModal ? (
              <RemoveModal
                toggle={this.toggleModal}
                toggleName="networkLeaveModal"
                onSave={this.leaveNetwork}
                message_body={
                  "Are you sure you want to leave network" +
                  (this.state.selectedNetworks.length > 1 ? "s" : "") +
                  " " +
                  this.getUserStr(this.state.selectedNetworks, "networks") +
                  "?"
                }
                message_header={"Remove User"}
                saveButton={"Remove"}
              />
            ) : null}

            {this.state.userAdminModal ? (
              <UserAdminModal
                toggle={this.toggleModal}
                toggleName="userAdminModal"
                users={this.state.selectedUsers}
                onSave={this.setAdmin}
                isAdmin={this.isAdmin(this.state.selectedUsers[0].username)}
              />
            ) : null}
          </div>
        ) : (
          <>
            {this.state.loaded ? (
              <>
                {" "}
                <div className="organization">
                  <div className="organization_title">
                    <h1>You are not part of an organization</h1>
                  </div>
                  <div className="organization_description">
                    For now, users cannot create organizations <br />
                    If you want yours here, contact us at{" "}
                    <a href="mailto:info@spatiam.com?subject=Spatiam DTN Manager - Creating my Organization">
                      info@spatiam.com
                    </a>
                  </div>
                </div>
              </>
            ) : null}
          </>
        )}
      </>
    );
  }

  notify_create = () => {
    store.addNotification({
      title: "Success!",
      type: "success",
      message: "Network created",
      insert: "top",
      container: "top-right",
      animationIn: ["animate__animated", "animate__fadeIn"],
      animationOut: ["animate__animated", "animate__fadeOut"],
      dismiss: {
        duration: 5000,
        onScreen: true,
        showIcon: true,
      },
    });
  };

  notify_add = () => {
    store.addNotification({
      title: "Success!",
      type: "success",
      message: "User added to organization",
      insert: "top",
      container: "top-right",
      animationIn: ["animate__animated", "animate__fadeIn"],
      animationOut: ["animate__animated", "animate__fadeOut"],
      dismiss: {
        duration: 5000,
        onScreen: true,
        showIcon: true,
      },
    });
  };

  notify_network_leave = (username) => {
    store.addNotification({
      type: "danger",
      message: "Left network selection",
      insert: "top",
      container: "top-right",
      animationIn: ["animate__animated", "animate__fadeIn"],
      animationOut: ["animate__animated", "animate__fadeOut"],
      dismiss: {
        duration: 5000,
        onScreen: true,
        showIcon: true,
      },
    });
  };

  notify_delete = () => {
    store.addNotification({
      type: "danger",
      message: "Removed user selection from organization",
      insert: "top",
      container: "top-right",
      animationIn: ["animate__animated", "animate__fadeIn"],
      animationOut: ["animate__animated", "animate__fadeOut"],
      dismiss: {
        duration: 5000,
        onScreen: true,
        showIcon: true,
      },
    });
  };

  notify_admin = () => {
    store.addNotification({
      type: "info",
      message: "User's admin rights updated",
      insert: "top",
      container: "top-right",
      animationIn: ["animate__animated", "animate__fadeIn"],
      animationOut: ["animate__animated", "animate__fadeOut"],
      dismiss: {
        duration: 5000,
        onScreen: true,
        showIcon: true,
      },
    });
  };
}

export default OrganizationDashboard;